import { DeleteOutline } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useDeleteProfileDialogs } from 'features/profile/hooks';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonWithLoader, Dialog } from 'shared/components';

export function ProfileDeleteButton() {
    const { t } = useTranslation('profile');
    const {
        closeText,
        onClose,
        confirmText,
        onConfirm,
        onOpen,
        open,
        message,
        isLoading,
        title
    } = useDeleteProfileDialogs();

    const dialogActions = [
        closeText ? ( 
            <Button key="close"
                variant="outlined"
                onClick={ onClose }
            >
                { closeText }
            </Button>
        ) : null,

        confirmText ? (
            <ButtonWithLoader key="confirm"
                variant="contained"
                color="error"
                onClick={ onConfirm }
                loading={ isLoading }
            >
                { confirmText }
            </ButtonWithLoader>
        ) : null
    ].filter(Boolean);

    return (
        <>
            <Button variant="text"
                color="error"
                startIcon={ <DeleteOutline fontSize="small" /> }
                onClick={ onOpen }
            >
                { t('deleteRequest.button') }
            </Button>

            <Dialog open={ open }
                onClose={ onClose }
                aria-labelledby="delete-confirm-dialog-title"
                aria-describedby="delete-confirm-dialog-description"
                variant="confirm"
                actions={ dialogActions }
                title={ title }
            >
                { message }
            </Dialog>
        </>
    );
}

export default memo(ProfileDeleteButton);
